import type { Entries } from './catalog';
import { operator } from './operator';

/** Las palabras en español de Snapshots: el objeto es una "instantánea" (decisión E9). */
export const es: Entries = {
	'app.name': 'Beyond Snapshots',
	'app.product': 'Snapshots',
	'app.tagline': 'Instantáneas inmutables de los paquetes de un proyecto.',
	'loading.who': 'quién está aquí',
	'loading.organizations': 'tus organizaciones',
	'loading.capture': 'la instantánea',
	'loading.storage': 'lo que guarda esta organización',
	'loading.files': 'sus archivos',
	'loading.file': 'el archivo',
	'loading.compare': 'las dos instantáneas',
	'state.departing': 'Iniciando sesión con Beyond Accounts…',
	'state.unavailable.reason': 'Nada de tus instantáneas ha cambiado.',
	'action.retry': 'Reintentar',
	'action.signin': 'Iniciar sesión con Beyond Accounts',
	'action.signout': 'Cerrar sesión',
	'action.back': 'Volver a las instantáneas',
	'action.delete': 'Eliminar instantánea',
	'action.restore': 'Restaurar instantánea',
	'action.rename': 'Guardar título',
	'action.cancel': 'Cancelar',
	'nav.captures': 'Instantáneas',
	'nav.storage': 'Almacenamiento',
	'nav.notifications': 'Notificaciones',
	'nav.project': 'Proyecto',
	'nav.organization': 'Organización',
	'nav.project.unknown': 'Proyecto desconocido',
	'page.list': 'Instantáneas · Beyond Snapshots',
	'page.capture': '{title} · {state} · Beyond Snapshots',
	'page.storage': 'Almacenamiento · Beyond Snapshots',
	'page.compare': 'Comparar instantáneas · Beyond Snapshots',
	'signin.title': 'Inicia sesión para ver las instantáneas',
	'signin.body': 'Inicia sesión con Beyond Accounts para abrir las instantáneas de tus organizaciones.',
	'signin.expired': 'Tu sesión caducó. Vuelve a iniciar sesión para continuar donde estabas.',
	'signin.revoked': 'Tu sesión se terminó: cerraste la sesión de Beyond o se terminó desde Beyond Accounts. Vuelve a iniciar sesión para continuar donde estabas.',
	'signin.beyond': 'Cerraste la sesión de Beyond en este navegador.',
	'signin.signedout': 'Cerraste la sesión de Snapshots.',
	'signin.unconfirmed': 'Cerraste la sesión aquí, pero Beyond Accounts no confirmó que la terminó. Termina sola cuando vence.',
	'signin.failed': 'Ese inicio de sesión no pudo completarse. Vuelve a empezarlo.',
	'signin.unavailable': 'Beyond Accounts no respondió, así que no se inició ninguna sesión. Reintenta en un momento.',
	'signin.incomplete': 'El último inicio de sesión no terminó, así que no se te envió de nuevo a Beyond Accounts. Empiézalo cuando quieras.',
	'signout.failed': 'El cierre de sesión no se confirmó, así que sigues con la sesión iniciada. Reintenta.',
	'suspended.title': 'Esta cuenta no puede usar Beyond',
	'suspended.lead': 'Tu cuenta de Beyond está suspendida, así que volver a iniciar sesión no servirá. Contacta con quien administra tu cuenta.',
	'unsaved.title': '¿Cerrar sesión con un título sin guardar?',
	'unsaved.message': 'El título que escribiste para «{title}» todavía no está guardado.',
	'unsaved.lost': 'El título que escribiste.',
	'unsaved.kept': 'La instantánea y su título guardado.',
	'unsaved.accept': 'Cerrar sesión en Beyond',
	'unsaved.keep': 'Seguir editando',
	'family.signout': 'Cerrar sesión',
	'notifications.title': 'Notificaciones',

	'captures.title': 'Instantáneas',
	'captures.untitled': 'Instantánea sin título',
	'title.more': '{name} y {count} más',
	'title.made': '{packages} · {time}',
	'captures.scope.all': 'Todas las instantáneas de tus organizaciones.',
	'captures.scope.project': 'En el proyecto {project}.',
	'captures.scope.organization': 'En {organization}.',
	'captures.make': 'Hacer una instantánea en Packages',
	'captures.column.title': 'Instantánea',
	'captures.column.project': 'Proyecto',
	'captures.column.organization': 'Organización',
	'captures.column.author': 'Hecha por',
	'captures.column.source': 'Origen',
	'captures.column.packages': 'Paquetes',
	'captures.column.size': 'Tamaño',
	'captures.column.created': 'Creada',
	'captures.column.state': 'Estado',
	'captures.column.deleted': 'Eliminada',
	'captures.column.remover': 'Eliminada por',
	'captures.column.recoverable': 'Recuperable hasta',
	'captures.filter.state': 'Estado',
	'captures.filter.current': 'Todas menos las eliminadas',
	'captures.state.pending': 'Pendiente',
	'captures.state.active': 'Lista',
	'captures.state.deleted': 'Eliminada',
	'captures.state.ended': 'Fallidas o canceladas',
	'captures.state.cancelled': 'Cancelada',
	'captures.state.failed': 'Fallida',
	'captures.empty.title': 'Aún no hay instantáneas',
	'captures.empty.body': 'Crea una instantánea de los paquetes de tu proyecto en Packages.',
	'captures.deleted': 'Mostrar las instantáneas eliminadas',
	'quota.near': 'Esta organización guarda {used} de sus {quota} instantáneas.',
	'quota.full': 'Esta organización llegó a su cuota: elimina instantáneas para hacer sitio a las nuevas.',
	'quota.storage': 'Las instantáneas de esta organización ocupan {used} de sus {quota}.',
	'quota.see': 'Ver el almacenamiento',
	'source.main': 'Main',
	'source.conversation': 'Una conversación',
	'source.local': 'Este equipo',
	'source.external': 'Otro servidor',
	'source.conduict': 'Conduict',
	'person.you': 'Tú',
	'person.member': 'Un miembro de {organization}',
	'person.someone': 'Un miembro de la organización',
	'list.search': 'Buscar instantáneas',
	'list.placeholder': 'Título, paquete, identidad o resumen',
	'list.all': 'Todas',
	'list.loading': 'Cargando instantáneas…',
	'list.failure': 'No se pudieron cargar las instantáneas.',
	'list.pages': 'Páginas de instantáneas',
	'list.matches': 'Ninguna instantánea coincide con «{query}».',
	'list.filtered': 'Ninguna instantánea coincide con este filtro.',
	'list.end.one': '{count} instantánea · nada más antiguo',
	'list.end.other': '{count} instantáneas · nada más antiguo',
	'list.removed': 'Eliminada por {person}',

	'unavailable.member.title': 'Aún no estás en una organización',
	'unavailable.member.reason': 'Únete a una organización para leer las instantáneas de sus proyectos.',
	'unavailable.member.owner': 'Una persona propietaria de una organización, invitándote; o tú, creando una en Beyond Accounts',
	'unavailable.member.action': 'Crear una organización',
	'unavailable.member.projects': 'Abrir Beyond Projects',
	'unavailable.capture.title': 'Esta instantánea no está disponible para ti',
	'unavailable.capture.reason': 'No existe, o pertenece a una organización de la que no formas parte.',
	'unavailable.capture.owner': 'Una persona propietaria o administradora de la organización que la tiene, agregándote allí',
	'unavailable.project.title': 'Las instantáneas de este proyecto no están disponibles para ti',
	'unavailable.project.reason': 'El proyecto no existe, se eliminó o pertenece a una organización de la que no formas parte.',
	'unavailable.project.owner': 'Una persona propietaria o administradora de la organización del proyecto',
	'unavailable.organization.title': 'Las instantáneas de esta organización no están disponibles para ti',
	'unavailable.organization.reason': 'La organización no existe, o no eres miembro de ella.',
	'unavailable.organization.owner': 'Una persona propietaria o administradora de la organización, agregándote allí',
	'unavailable.empty.title': 'Aún no hay instantáneas de este proyecto',
	'unavailable.empty.reason': 'Crea las instantáneas de este proyecto en Packages. Quienes acceden al proyecto pueden leerlas.',
	'unavailable.empty.owner': 'Una persona desarrolladora, administradora o propietaria de la organización del proyecto',
	'unavailable.empty.action': 'Hacer una instantánea en Packages',
	'unavailable.enable.title': 'Packages no está habilitado para este proyecto',
	'unavailable.enable.reason': 'Las instantáneas de este proyecto se hacen en Packages, que aún no está habilitado aquí.',
	'unavailable.enable.owner': 'Una persona propietaria o administradora de la organización del proyecto',
	'unavailable.enable.action': 'Habilitar Packages para este proyecto',
	'first.title': 'Tu primera instantánea',
	'first.enable': 'Habilitar Packages para este proyecto',
	'first.enable.owner': 'Lo habilita una persona propietaria o administradora de la organización del proyecto',
	'first.make': 'Hacer una instantánea en Packages',
	'first.publish': 'Publicarla en CDN',
	'first.publish.detail': 'Desde la página de la instantánea, cuando esté completa',
	'unavailable.all': 'Ver todas tus instantáneas',

	'capture.title': 'Instantánea',
	'capture.facts': 'Sobre esta instantánea',
	'capture.facts.created': 'Creada el {date}',
	'capture.identity': 'Identidad',
	'capture.author': 'Hecha por',
	'capture.owner': 'Organización',
	'capture.created': 'Creada',
	'capture.completed': 'Lista desde',
	'capture.ended': 'Terminada',
	'capture.remover': 'Eliminada por',
	'capture.provenance': 'Origen',
	'capture.provenance.main': 'Main',
	'capture.provenance.conversation': 'La copia de una conversación',
	'capture.provenance.local': 'Este equipo',
	'capture.provenance.external': 'Otro servidor',
	'capture.provenance.conduict': 'Conduict',
	'capture.provenance.unknown': 'Sin registrar',
	'capture.connection': 'Conexión',
	'capture.connection.local': 'Este equipo',
	'capture.connection.external': 'Otro servidor',
	'capture.connection.conduict': 'Conduict',
	'capture.toolchain': 'Herramientas',
	'capture.repository': 'Repositorio',
	'capture.made': 'Hecha a través de',
	'capture.used': 'La usa',
	'capture.used.none': 'Nada la usa',
	'capture.use.release': 'Una versión publicada en {product}',
	'capture.use.other': 'Algo en {product}',
	'capture.same': 'Mismo contenido que',
	'capture.same.earlier': 'Una instantánea anterior',
	'capture.packages': 'Paquetes',
	'capture.packages.count.one': '{count} paquete',
	'capture.packages.count.other': '{count} paquetes',
	'capture.package.path': 'Ruta',
	'capture.package.name': 'Nombre',
	'capture.package.version': 'Versión',
	'capture.package.digest': 'Resumen',
	'capture.package.bytes': 'Tamaño',
	'capture.package.dependencies': 'Dependencias',
	'capture.package.dependencies.none': 'Sin dependencias',
	'capture.package.unstored': 'Aún no recibido',
	'capture.package.received': 'Recibido',
	'capture.files.folder': 'Carpeta',
	'capture.package.damaged': 'Sus bytes guardados ya no coinciden con su resumen. Vuelve a hacer la instantánea en Packages.',
	'capture.download': 'Descargar',
	'capture.download.named': 'Descargar {name}',
	'capture.files': 'Archivos',
	'capture.files.show': 'Archivos de {name}',
	'capture.files.count.one': '{count} archivo',
	'capture.files.count.other': '{count} archivos',
	'capture.files.truncated': 'Solo se listan las primeras {count} entradas.',
	'capture.files.unreadable': 'Sus archivos no se pueden listar. Descárgalo para leerlo.',
	'capture.files.empty': 'No contiene archivos.',
	'capture.file.binary': 'Este archivo no es texto. Descarga el paquete para abrirlo.',
	'capture.file.truncated': 'Solo se muestran sus primeros 512 KB.',
	'capture.file.close': 'Cerrar',
	'capture.file.text': 'Texto de {name}',
	'capture.configuration': 'Configuración de publicación',
	'capture.configuration.hint': 'La configuración de publicación del proyecto cuando se hizo la instantánea.',
	'capture.digest.help': 'El SHA-256 del archivo de este paquete: nombra exactamente estos bytes.',
	'capture.title.label': 'Título',
	'capture.publish': 'Publicar en CDN',
	'capture.open': 'Abrir en Packages',
	'capture.compare': 'Comparar',
	'capture.compare.previous': 'Comparar con la anterior',
	'capture.compare.with': 'Comparar con otra instantánea de este proyecto',
	'capture.compare.none': 'No hay otra instantánea de este proyecto',

	'capture.standing.pending': 'Pendiente',
	'capture.standing.completed': 'Lista',
	'capture.standing.failed': 'Fallida',
	'capture.standing.cancelled': 'Cancelada',
	'capture.standing.deleted': 'Eliminada, recuperable hasta el {until}',

	'capture.awaited.title': 'Recibiendo los paquetes de esta instantánea',
	'capture.awaited.complete': 'Completar la instantánea',
	'capture.awaited.sender.local': 'Packages en este equipo los está enviando. Cerrar Packages allí detiene la instantánea.',
	'capture.awaited.sender.external': 'Packages en otro servidor los está enviando. Detener ese servidor detiene la instantánea.',
	'capture.awaited.sender.conduict': 'Una máquina de Conduict los está enviando. Detener la máquina detiene la instantánea.',
	'capture.awaited.sender.workspace': 'Un entorno de Workspace los está enviando. Detenerlo detiene la instantánea.',
	'capture.awaited.sender.packages': 'Packages los está enviando. Cerrarlo detiene la instantánea.',
	'capture.awaited.deadline': 'Falla a las {time} si no llegaron todos los paquetes.',
	'capture.awaited.stalled': 'No llegaron a tiempo {missing} de sus {total} paquetes, así que esta instantánea falló.',
	'capture.awaited.gone': 'Esta instantánea ya no existe.',
	'capture.awaited.again': 'Volver a intentarlo aquí no sirve: vuelve a hacer la instantánea en Packages.',
	'capture.ended.cancelled': 'Cancelada {date} por {who}, antes de que llegaran todos los paquetes.',
	'capture.ended.failed': 'No llegaron a tiempo {missing} de sus {total} paquetes, así que falló {date}.',
	'capture.ended.kept': 'Su registro se elimina {until}. Vuelve a hacer la instantánea en Packages.',

	'capture.more': 'Más acciones para {title}',
	'capture.cancel.item': 'Cancelar {title}…',
	'capture.cancel.question': '¿Cancelar «{title}»?',
	'capture.cancel.message': 'Snapshots deja de recibir sus paquetes.',
	'capture.cancel.lost': 'Los paquetes recibidos hasta ahora',
	'capture.cancel.kept': 'Un registro de ella, hasta el {until}',
	'capture.cancel.kept.period': 'Un registro de ella, durante unos días',
	'capture.cancel.recovery': 'Ninguna: vuelve a hacer la instantánea en Packages',
	'capture.cancel.confirm': 'Cancelar instantánea',
	'capture.cancel.keep': 'Seguir recibiendo',
	'capture.cancelled.outcome': 'Instantánea cancelada.',
	'capture.delete.item': 'Eliminar {title}…',
	'capture.delete.question': '¿Eliminar «{title}»?',
	'capture.delete.message': 'Esta instantánea desaparece del proyecto. Sus paquetes ya no se podrán leer ni descargar.',
	'capture.delete.lost': 'La lectura y la descarga de sus paquetes, para todos',
	'capture.delete.lost.held': 'La lectura y la descarga de sus paquetes; y {releases} ya no se podrán promover ni restaurar a ella',
	'capture.delete.kept': 'Las versiones publicadas que la usan siguen sirviendo lo que publicaron; se puede restaurar hasta el {until}',
	'capture.delete.kept.period': 'Las versiones publicadas que la usan siguen sirviendo lo que publicaron; se puede restaurar durante un periodo',
	'capture.delete.recovery': 'Un propietario o administrador puede restaurarla hasta que termine el período de recuperación. Después se elimina definitivamente.',
	'capture.delete.recovery.held': 'Un propietario o administrador puede restaurarla mientras sea recuperable. Las versiones la conservan mientras la necesiten.',
	'capture.delete.confirm': 'Eliminar instantánea',
	'capture.delete.keep': 'Conservar instantánea',
	'capture.deleted.outcome': 'Instantánea eliminada. Se puede restaurar hasta el {until}.',
	'capture.restored.outcome': 'Instantánea restaurada.',
	'capture.retitled.outcome': 'Título guardado.',
	'reason.delete': 'Las personas propietarias y administradoras eliminan instantáneas',
	'reason.cancel': 'Quien la empezó, o una persona propietaria o administradora, la cancela',
	'reason.rename': 'Las personas desarrolladoras, administradoras y propietarias renombran instantáneas',

	'problem.unknown': 'Puede que el cambio se haya hecho. Compruébalo antes de volver a intentarlo.',
	'problem.unchanged': 'No se cambió nada.',
	'problem.check': 'Revisar la instantánea',
	'problem.forbidden': 'Tu rol no permite esto aquí, así que nada cambió. Vuelve a leer la instantánea para ver qué puedes hacer.',
	'problem.conflict': 'Cambió mientras tanto, así que no se cambió nada. Vuelve a leerla y reintenta.',
	'problem.missing': 'Ya no existe, o no te corresponde leerla.',
	'problem.admission': 'Tu rol no hace instantáneas en este proyecto, así que nada cambió.',
	'problem.admission.enable': 'Packages no está habilitado para este proyecto, así que nada cambió. Se habilita en Beyond Projects.',
	'problem.state.active': 'Ya está completada, así que nada cambió.',
	'problem.state.deleted': 'Se eliminó, así que nada cambió. Restáurala primero.',
	'problem.state.cancelled': 'Se canceló, así que nada cambió. Vuelve a hacer la instantánea en Packages.',
	'problem.state.failed': 'Falló, así que nada cambió. Vuelve a hacer la instantánea en Packages.',
	'problem.state.expired': 'Pasó su plazo para completarse, así que nada cambió. Vuelve a hacer la instantánea en Packages.',
	'problem.incomplete': 'Aún no está completa, así que sus paquetes no se pueden leer.',
	'problem.invalid': 'Snapshots no aceptó lo que se envió, así que nada cambió. Revísalo y reintenta.',
	'problem.large': 'Es más grande de lo que Snapshots acepta, así que nada cambió.',
	'problem.limit.snapshots': 'Esta organización guarda como mucho {limit} instantáneas, así que nada cambió. Elimina algunas para hacer sitio.',
	'problem.limit.storage': 'Las instantáneas de esta organización ocupan como mucho {limit}, así que nada cambió. Elimina algunas para hacer sitio.',
	'problem.limit.captures': 'Tienes {limit} instantáneas pendientes, así que nada cambió. Espera a que termine una, o cancela una.',
	'problem.limit.bytes': 'Las instantáneas pendientes de esta organización ocupan como mucho {limit}, así que nada cambió. Espera a que termine una.',
	'problem.limit.busy': 'Se pidió demasiado a la vez, así que nada cambió. Espera un minuto y reintenta.',
	'problem.refused': 'Snapshots no aceptó esto, así que nada cambió. Vuelve a leer la página antes de reintentar.',

	'outage.cause': '{name} no respondió',
	'outage.storage': 'El almacenamiento de Beyond Snapshots no respondió',
	'outage.read.list': 'La lista de instantáneas',
	'outage.read.storage': 'Lo que guarda esta organización',
	'outage.read.capture': 'Esta instantánea',
	'outage.read.before': 'La instantánea de antes',
	'outage.read.after': 'La instantánea de después',
	'outage.read.file': 'El archivo {name}',

	'storage.unnamed': 'Organización sin nombre',
	'storage.choose': 'Elige una organización',
	'storage.title': 'Almacenamiento',
	'storage.scope': 'En {organization}.',
	'storage.snapshots': 'Instantáneas guardadas',
	'storage.bytes': 'Almacenado',
	'storage.meter.snapshots': '{used} de {quota}',
	'storage.meter.bytes': '{used} de {quota}',
	'storage.deleted.one': '{count} instantánea eliminada aún ocupa {bytes} hasta que se elimine definitivamente.',
	'storage.deleted.other': '{count} instantáneas eliminadas aún ocupan {bytes} hasta que se eliminen definitivamente.',
	'storage.projects': 'Por proyecto',
	'storage.column.project': 'Proyecto',
	'storage.column.snapshots': 'Instantáneas',
	'storage.column.bytes': 'Almacenado',
	'storage.empty': 'Esta organización aún no guarda instantáneas.',
	'storage.search': 'Buscar proyectos',
	'storage.checked': 'Contado {time}',
	'storage.same': 'Los mismos bytes se guardan una sola vez, por muchas instantáneas que los tengan.',

	'compare.title': 'Comparar instantáneas',
	'compare.before': 'Antes',
	'compare.after': 'Después',
	'compare.same': 'Mismo contenido: cada paquete tiene los mismos bytes.',
	'compare.change.added': 'Agregado',
	'compare.change.removed': 'Quitado',
	'compare.change.version': 'Cambió de versión',
	'compare.change.content': 'Cambió el contenido',
	'compare.change.same': 'Igual',
	'compare.version': '{before} → {after}',
	'compare.files.show': 'Archivos que cambiaron en {name}',
	'compare.files.none': 'No cambió ningún archivo.',
	'compare.files.count.one': '{count} archivo cambió',
	'compare.files.count.other': '{count} archivos cambiaron',
	'compare.files.unreadable': 'Sus archivos no se pueden comparar.',
	'compare.file.added': 'Agregado',
	'compare.file.removed': 'Quitado',
	'compare.file.changed': 'Cambiado',
	'compare.missing': 'Las dos instantáneas deben ser de las que puedes leer.',
	// The cloud packages allowances, for Beyond operators (`operator.ts`)
	...operator.es
};
